import React from 'react'
import { useSiteMetadata } from '../hooks/useSiteMetadata'

export const Seo = ({ authorData, children, datePublished, dateModified, description, image, isBlogPost, pathname, title }) => {
  const { companyName, description: defaultDescription, image: defaultImage, logo, twitterUsername, siteUrl } = useSiteMetadata()
  if (image) {
    image = `${image?.split('?')[0]}?format&q=&auto=compress&fit=crop&w=1200&h=630&border=5,4338CA&pad=10&mark=https://images.prismic.io/apexauctions/917fa53e-a8ed-4100-9ed0-e5ab582d2aae_Apex-Auctions_Icon.png%3Fw%3D150`
  }
  const seo = {
    companyName,
    description: description || defaultDescription,
    image: image || `${siteUrl}${defaultImage}`,
    logo: `${siteUrl}${logo}`,
    title: title || companyName,
    twitterUsername,
    url: `${siteUrl}${pathname || ``}`
  }
  const author = {
    name: authorData?.document?.data.name || twitterUsername,
    image: authorData?.document?.data.image.url,
    url: `${siteUrl}${authorData?.url ? authorData.url : ''}`
  }

  const baseSchema = [
    {
      '@context': 'https://schema.org/',
      '@type': 'WebSite',
      url: seo.url,
      name: seo.companyName,
      description,
      sameAs: [
        'https://www.facebook.com/ApexAuctionsUK/',
        'https://twitter.com/apexauctions',
        'https://www.linkedin.com/company/apex-auctions-limited/',
        'https://www.youtube.com/user/Industrialauctions',
        'https://www.instagram.com/apexauctionsltd/'
      ]
    },
    {
      '@context': 'https://schema.org/',
      '@type': 'Organization',
      url: seo.url,
      name: seo.companyName,
      sameAs: [
        'https://www.facebook.com/ApexAuctionsUK/',
        'https://twitter.com/apexauctions',
        'https://www.linkedin.com/company/apex-auctions-limited/',
        'https://www.youtube.com/user/Industrialauctions',
        'https://www.instagram.com/apexauctionsltd/'
      ],
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Brighton',
        postalCode: 'BN1 1AL',
        streetAddress: '69 Middle Street'
      },
      logo: {
        '@type': 'ImageObject',
        url: seo.logo
      }
    }
  ]

  const schema = isBlogPost
    ? [
        ...baseSchema,
        {
          '@context': 'https://schema.org/',
          '@type': ['BlogPosting', 'NewsArticle', 'Article'],
          url: seo.url,
          name: seo.companyName,
          headline: seo.title,
          image: [seo.image],
          description: seo.description,
          author: {
            '@type': 'Person',
            name: author.name,
            url: author.url
          },
          publisher: {
            '@type': 'Organization',
            url: seo.url,
            logo: {
              '@type': 'ImageObject',
              url: author.image
            },
            name: author.name
          },
          mainEntityOfPage: {
            '@type': 'WebSite',
            '@id': seo.url
          },
          datePublished: datePublished,
          dateModified
        }
      ]
    : baseSchema

  return (
    <>
      {pathname !== '/' && (
        <>
          <title>{seo.title}</title>
          <meta name='description' content={seo.description} />
          <link rel='canonical' href={seo.url} data-baseprotocol='https:' data-basehost={siteUrl} />
        </>
      )}

      <meta name='author' content={author.name} />
      <meta name='image' content={seo.image} />
      <meta property='og:title' content={seo.title} />
      <meta property='og:description' content={seo.description} />
      <meta name='image' property='og:image' content={`${seo.image}`} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:type' content='website' />
      <meta property='og:url' content={seo.url} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:creator' content={seo.twitterUsername} />
      <meta name='twitter:description' content={seo.description} />
      <meta property='twitter:domain' content={siteUrl} />
      <meta name='twitter:image' content={`${seo.image}`} />
      <meta name='twitter:title' content={seo.title} />
      <meta property='twitter:url' content={seo.url} />
      <script type='application/ld+json'>{JSON.stringify(schema)}</script>
      {children}
    </>
  )
}

export default Seo
